// PLANTS MUSHROOMS
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const mushroomsData: PlantData[] = [
  {
    id: 'oyster-mushroom',
    name: 'Oyster Mushroom',
    scientificName: 'Pleurotus ostreatus',
    category: 'mushroom',
    spacing: 6,
    rowSpacing: 6,
    daysToGermination: 14,
    daysToHarvest: 30,
    sun: 'shade',
    water: 'high',
    soil: 'wood',
    phMin: 6,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Fan-shaped mushrooms growing on logs or straw. Mild seafood flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '2-4 inches',
    spread: '3-6 inches',
    family: 'Pleurotaceae',
    varieties: ['Pearl Oyster', 'Blue Oyster'],
    uses: ['cooking', 'stir fry', 'soup']
  },
  {
    id: 'shiitake-mushroom',
    name: 'Shiitake Mushroom',
    scientificName: 'Lentinula edodes',
    category: 'mushroom',
    spacing: 6,
    rowSpacing: 6,
    daysToGermination: 21,
    daysToHarvest: 60,
    sun: 'shade',
    water: 'medium',
    soil: 'wood',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Popular Asian mushroom grown on oak logs. Rich umami flavor.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '2-4 inches',
    spread: '2-4 inches',
    family: 'Omphalotaceae',
    varieties: ['Wide Range', 'Cold Weather'],
    uses: ['cooking', 'medicinal', 'dried']
  },
  {
    id: 'lions-mane-mushroom',
    name: 'Lions Mane Mushroom',
    scientificName: 'Hericium erinaceus',
    category: 'mushroom',
    spacing: 6,
    rowSpacing: 6,
    daysToGermination: 21,
    daysToHarvest: 45,
    sun: 'shade',
    water: 'high',
    soil: 'wood',
    phMin: 5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'White cascading spines resembling lion mane. Crab-like texture.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '4-6 inches',
    spread: '4-8 inches',
    family: 'Hericiaceae',
    varieties: ['Pom Pom', 'White'],
    uses: ['cooking', 'brain health', 'crab substitute']
  },
  {
    id: 'portobello-mushroom',
    name: 'Portobello Mushroom',
    scientificName: 'Agaricus bisporus',
    category: 'mushroom',
    spacing: 6,
    rowSpacing: 6,
    daysToGermination: 14,
    daysToHarvest: 45,
    sun: 'shade',
    water: 'medium',
    soil: 'compost',
    phMin: 6.5,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Large meaty mushrooms, mature cremini. Steak substitute.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '3-5 inches',
    spread: '4-6 inches',
    family: 'Agaricaceae',
    varieties: ['Portobello', 'Baby Bella'],
    uses: ['grilling', 'stuffing', 'burgers']
  },
  {
    id: 'white-button-mushroom',
    name: 'White Button Mushroom',
    scientificName: 'Agaricus bisporus',
    category: 'mushroom',
    spacing: 4,
    rowSpacing: 4,
    daysToGermination: 14,
    daysToHarvest: 35,
    sun: 'shade',
    water: 'medium',
    soil: 'compost',
    phMin: 6.5,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Common grocery store mushroom, mild flavor. Easy to grow indoors.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '2-3 inches',
    spread: '2-3 inches',
    family: 'Agaricaceae',
    varieties: ['White Button', 'Cream'],
    uses: ['cooking', 'salads', 'pizza']
  },
  {
    id: 'maitake-mushroom',
    name: 'Maitake Mushroom',
    scientificName: 'Grifola frondosa',
    category: 'mushroom',
    spacing: 8,
    rowSpacing: 8,
    daysToGermination: 21,
    daysToHarvest: 60,
    sun: 'shade',
    water: 'high',
    soil: 'wood',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Hen of the woods, frilly clusters at base of oak trees. Medicinal.',
    hardinessZones: 'indoor',
    plantingSeason: 'any',
    height: '4-8 inches',
    spread: '6-12 inches',
    family: 'Meripilaceae',
    varieties: ['Maitake', 'Hen of the Woods'],
    uses: ['cooking', 'medicinal', 'soup']
  }
]
